import { render } from "./AddTranslationKeyModal.vue?vue&type=template&id=8b18e3a4"
import script from "./AddTranslationKeyModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AddTranslationKeyModal.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__